module.exports = __webpack_public_path__ + "static/media/PCI.b806b1e6.png";